import { Alert } from "@package/subframe/components/Alert";

import { EventRecordDocument } from "./documents/EventRecordDocument";

interface AcknowledgementDocumentViewerProps {
  /** Which renderer to use. Currently only EVENT_RECORD is wired. */
  kind: string | undefined;
  payload: Record<string, unknown> | undefined;
}

/**
 * Picks a renderer for the document being acknowledged (AC11).
 *
 * Purely presentational, and the additive seam the ticket asks for: when Risk
 * Hub and Policy Hub land, each adds one case here and one sibling under
 * `documents/`. Nothing else in the flow changes.
 */
export function AcknowledgementDocumentViewer({
  kind,
  payload,
}: AcknowledgementDocumentViewerProps) {
  if (!kind || !payload) {
    // Reachable when the source has been deleted: the acknowledgement record
    // survives on purpose, so the history still reads even though the document
    // does not. Say that rather than showing an empty box.
    return (
      <Alert
        variant="neutral"
        title="This document is no longer available"
        description="The item it referred to has been removed. Your acknowledgement record is unaffected."
      />
    );
  }

  switch (kind) {
    case "EVENT_RECORD":
      return <EventRecordDocument payload={payload} />;
    default:
      return (
        <Alert
          variant="neutral"
          title="This document cannot be displayed here yet"
          description="Open it from its own section to read it in full."
        />
      );
  }
}
